import { Controller } from '@hotwired/stimulus'
import { MutexFetcher } from 'api/mutex_fetcher'
import Routes from 'common/rails_routes'
class UserAnnouncementsController extends Controller {
  connect () {
    this.fetcher = new MutexFetcher()
  }

  create () {
    this.fetcher.call({
      url: Routes.user_announcement_path(),
      method: 'POST',
      body: { id: this.idValue },
      callback: () => {
        this.selfTarget.classList.add('d-none')
      }
    })
  }
}
UserAnnouncementsController.targets = ['self', 'id']
UserAnnouncementsController.values = { id: Number }
export default UserAnnouncementsController
